// 二级品牌馆配置 u联盟
export default {
  'uleague.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST059004012200001668501873',
      storeName: '创新生态馆',
      microHost: 'test-y.ubanquan.cn'
    },
    test: {
      storeNo: 'ST059004012200001668501873',
      storeName: '创新生态馆',
      microHost: 'test-y.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001669031544',
      storeName: 'U联盟',
      microHost: 'uleague-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001669031544',
      storeName: 'U联盟',
      microHost: 'uleague-brand.ubanquan.cn'
    }
  }
};